import React from "react";
import badge_lock from "../../../../utilities/images/engage/badge_lock.png";

const ScholarLeagueBadgesAndEarnPoints = ({ leagueData, leagueSteps, earnPoints }) => {
  const getPointsVariantClass = (title) => {
    const key = String(title || "").toLowerCase().trim();
    if (key.includes("easy")) return "points-value-easy";
    if (key.includes("medium")) return "points-value-medium";
    if (key.includes("hard")) return "points-value-hard";
    if (key.includes("participation")) return "points-value-participation";
    return "";
  };

  return (
    <div className="scholar-league-badges-earn">
      <div className="badge-section">
        <h3>{leagueData?.badges_title || ""}</h3>
        <div className="badge-grid">
          {leagueSteps.map((step) => (
            <div key={`${step.name}-badge`} className={`badge-card status-${step.status}`}>
              <span className="badge-dot">
                {Number(step?.achievedCount) > 0 ? (
                  <span className="badge-achieved-count-chip">{`x${Number(step.achievedCount)}`}</span>
                ) : null}
                <img
                  src={step.iconUrl}
                  alt={`${step.name} badge`}
                  className="badge-dot-icon"
                />
              </span>
              <p>{step.name}</p>
              <small>{step.range}</small>
              <div className="badge-status-row">
                {step.status === "achieved" ? (
                  <span className="badge-achieved-pill">Achieved</span>
                ) : (
                  <img
                    src={badge_lock}
                    alt="Locked"
                    className="badge-lock-icon"
                    loading="lazy"
                  />
                )}
              </div>
            </div>
          ))}
        </div>
      </div>

      <div className="points-section">
        <h3>{leagueData?.earn_points_title || ""}</h3>
        <div className="points-grid">
          {earnPoints.map((item) => (
            <div key={item.title} className="points-card">
              <div>
                <p className="points-label">{item.title}</p>
                <small>{item.description}</small>
              </div>
              <strong className={getPointsVariantClass(item.title)}>{item.points}</strong>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ScholarLeagueBadgesAndEarnPoints;
